import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const updateAchievement = createAsyncThunk(
  "AgentAchievement/updateAchievement",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/users/achievements/${data.id}`,
        { value: data?.value },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
